var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionCompleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Final-5.2",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 3000 1000",
    style: {
      whiteSpace: "pre"
    }
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    opacity: 1,
    transform: "translate(2497.318 504) scale(.59333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-Layer-2",
    opacity: 1,
    transform: "rotate(-90)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    values: "-90;630;630",
    keyTimes: "0;0.575909;1",
    calcMode: "spline",
    keySplines: "0.62 0 0.481917 0.784347;0 0 0 0",
    dur: "2.2s",
    repeatCount: 1,
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse-1-2",
    opacity: 1,
    transform: "scale(1.51614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-Path-1-2",
    d: "M0-260.54c143.892 0 260.54 116.648 260.54 260.54 0 143.892-116.648 260.54-260.54 260.54-143.892 0-260.54-116.648-260.54-260.54 0-143.892 116.648-260.54 260.54-260.54z",
    stroke: "#02bd9c",
    strokeOpacity: 1,
    strokeWidth: 40,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: 1636.59,
    strokeDashoffset: 1634.89
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "transparent;transparent;#02bd9c;#02bd9c",
    keyTimes: "0;0.545455;0.575909;1",
    dur: "2.2s",
    repeatCount: 1,
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "1634.89;799.059;0;0",
    keyTimes: "0;0.303182;0.575909;1",
    calcMode: "spline",
    keySplines: "0.494726 0 0.58 1;0.42 0 0.58 1;0 0 0 0",
    dur: "2.2s",
    repeatCount: 1,
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fill-effect",
    opacity: 1,
    transform: "rotate(-90.207) scale(.92)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "scale",
    values: "0.92 0.92;0.92 0.92; 0.92 0.92; 0 0; 0 0",
    keyTimes: "0;0.454545;0.575909;0.696818;1",
    calcMode: "spline",
    keySplines: "0 0 0 0; 0 0 0 0; 0.62 0 0.38 1; 0 0 0 0",
    dur: "2.2s",
    repeatCount: 1,
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse-1",
    opacity: 1,
    transform: "scale(1.51614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-Path-1",
    fill: "#fff",
    d: "M0-260.54c143.892 0 260.54 116.648 260.54 260.54 0 143.892-116.648 260.54-260.54 260.54-143.892 0-260.54-116.648-260.54-260.54 0-143.892 116.648-260.54 260.54-260.54z",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Tick",
    opacity: 1,
    transform: "matrix(.602 0 0 .602 2197 202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TickWrapper",
    opacity: 1,
    transform: "matrix(.78 0 0 .78 253.8 305.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-1",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-3",
    fill: "none",
    d: "M0 268.252l220.914 220.914L599.623 0",
    stroke: "#fff",
    strokeOpacity: 1,
    strokeWidth: 70,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: 931.05,
    strokeDashoffset: -1862
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "-931.05;-931.05;-1862;-1862",
    keyTimes: "0;0.696818;0.992273;1",
    calcMode: "spline",
    keySplines: "0 0 0 0;0.62 0 0.38 1;0 0 0 0",
    dur: "2.2s",
    repeatCount: 1
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;1;1",
    keyTimes: "0;0.696819;0.70;1",
    dur: "2.2s",
    repeatCount: 1
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Wallet",
    transform: "translate(265.998 219.998) scale(.41313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-5",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-4",
    fill: "#000",
    d: "M1241.04 431.666h-53.96V323.75c0-29.678-24.28-53.959-53.96-53.959H952.365L842.29 31.295C833.063 11.871 813.152 0 792.108 0a52.776 52.776 0 00-22.123 4.856L154.86 269.791H53.958C24.281 269.791 0 294.072 0 323.75v917.29c0 29.68 24.281 53.96 53.958 53.96H1241.04c29.68 0 53.96-24.28 53.96-53.96V485.625c0-29.678-24.28-53.959-53.96-53.959zM1133.12 323.75v107.916h-109.53c-.54-4.856-1.08-9.712-3.24-14.568l-43.165-93.348h155.935zM53.958 371.772l111.694-48.022 125.183-53.959L791.569 53.958h1.619l100.416 215.833 25.306 53.959 49.642 107.916H81.477l-27.519-59.354v-.54zM1241.04 909.197h-142.99c-39.93 0-72.84-32.914-72.84-72.843v-16.188c0-39.929 32.91-72.844 72.84-72.844h142.99v161.875zm0-215.833h-142.99c-70.14 0-126.8 56.656-126.8 126.802v16.188c0 69.606 56.66 126.802 126.8 126.802h142.99v277.884H53.958V485.625H1241.04v207.739z",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ProgressBar",
    transform: "translate(1682 514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-1",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-2",
    fill: "none",
    d: "M-732-14H418",
    stroke: "#02bd9c",
    strokeOpacity: 1,
    strokeWidth: 30,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: 105,
    strokeDashoffset: 0
  })))));
}
SvgTransactionCompleted.displayName = 'TransactionCompleted';
export default SvgTransactionCompleted;